export class Animation2DParm {
}
